import { render, staticRenderFns } from "./WidgetActiveReleaseNotes.vue?vue&type=template&id=f3a3e488"
import script from "./WidgetActiveReleaseNotes.vue?vue&type=script&lang=js"
export * from "./WidgetActiveReleaseNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports